import { LoginDomainPrompt, LoginWrapper, } from '@innovyze/stylovyze/lib/components';
import React from 'react';
export default function LoginDomainPromptProvider() {
    return (React.createElement(LoginWrapper, { initialValues: { domain: '' } },
        React.createElement(LoginDomainPrompt, null)));
}
